import chat from './reducers/chat'
import info from './reducers/info'

export const reducerList = {
  chat,
  info
}

export default reducerList
